module.exports = __webpack_public_path__ + "img/831-c3127b.png";